<template>
  <v-app>
    <Navbar :voltar="true" app />
    <Sidebar />
    <v-main>
      <v-container class="container" fluid>
        <Breadcrumbs :items="items" />
        <v-card class="mx-auto" max-width="1200" elevation="1">
          <v-toolbar color="#343F53">
            <v-card-title
              class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
            >
              <span style="color: white">MENSAGENS</span>
            </v-card-title>
          </v-toolbar>

          <v-card-text>
            <v-card class="pa-4" elevation="0" rounded="lg">
              <v-row>
                <v-col cols="6"></v-col>
                <v-col cols="6" class="px-0 pb-0"
                  ><v-text-field
                    v-model="search"
                    label="Filtrar"
                    variant="outlined"
                    density="compact"
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    rounded="lg"
                    class="bg-white"
                /></v-col>
              </v-row>
            </v-card>
            <v-data-table
              :headers="headers"
              :items="serverItems"
              :items-per-page="itemsPerPage"
              :loading="loading"
              loading-text="Buscando..."
              :search="search"
              items-per-page-text="Mensagens por página"
              :page-text="'{0}-{1} de {2}'"
              :sort-by="[{ key: 'id', order: 'desc' }]"
              class="elevation-0"
            >
              <template #item.mensagem="{ item }">
                <span>{{
                  truncateString(item.mensagem)
                }}</span>
              </template>
              <template #item.nomeCliente="{ item }">
                <span>{{ item.nomeCliente }}</span>
              </template>
              <template #item.nomeHomenageado="{ item }">
                <span>{{ item.nomeHomenageado }}</span>
              </template>
              <template #item.telefone="{ item }">
                <span>{{ item.telefone }}</span>
              </template>
              <template #item.aprovado="{ item }">
                <div class="d-flex flex-row flex-md-row my-4 align-center">
                  <v-chip
                    :color="item.aprovado ? 'green' : 'red'"
                    class="text-white mb-5 mr-3"
                    label
                    size="small"
                  >
                    {{ item.aprovado ? "Aprovado" : "Desaprovado" }}
                  </v-chip>
                </div>
              </template>
              <template #item.acoes="{ item }">
                <div class="ml-md-4 d-flex flex-row align-start justify-center">
                  <v-switch
                    v-model="item.aprovado"
                    color="#343F53"
                    @click="editarStatusMensagem(item.id, !item.aprovado)"
                    class="mr-4"
                  />
                  <v-btn
                    rounded="lg"
                    variant="text"
                    @click="gerenciarMensagem(item)"
                    color="#343F53"
                    class="d-flex align-center justify-center mt-2"
                  >
                    <v-icon size="28">mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </template>
              <template #no-data>
                <div class="text-center py-4 text-medium-emphasis">
                  Nenhuma mensagem encontrada.
                </div>
              </template>
            </v-data-table>
            <v-col cols="12" class="text-end"> </v-col>
          </v-card-text>
        </v-card>
      </v-container>
      <v-dialog v-model="dialog" max-width="600">
        <v-card elevation="0">
          <v-toolbar color="#343F53">
            <v-card-title class="text-h5 grey lighten-2">
              <span class="font-weight-bold">Edição Mensagem</span>
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-row no-gutter>
              <v-col cols="12" class="py-0">
                <v-text-field
                  label="Nome do Cliente"
                  outlined
                  color="#343F53"
                  class="mt-4"
                  maxlength="22"
                  v-model="mensagemEditar.nomeCliente"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-text-field
                  label="Nome da Mãe"
                  outlined
                  color="#343F53"
                  class="mt-4"
                  maxlength="22"
                  v-model="mensagemEditar.nomeHomenageado"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-textarea
                  label="Mensagem"
                  rows="4"
                  outlined
                  :counter="145"
                  maxlength="145"
                  color="#343F53"
                  class="mt-4"
                  v-model="mensagemEditar.mensagem"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="dialog = false" class="botao mr-2" color="#343F53">
              <v-icon>mdi-close-circle</v-icon> Fechar</v-btn
            >
            <v-btn variant="flat" class="botao" color="#343F53"
              ><v-icon>mdi-check</v-icon> Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from "@/components/restrito/Navbar.vue";
import Footer from "@/components/restrito/Footer.vue";
import Sidebar from "@/components/restrito/Sidebar.vue";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "Mensagens",
  components: {
    Navbar,
    Footer,
    Sidebar,
  },
  mounted() {
    this.buscarMensagensPainel();
  },
  methods: {
    truncateString(str) {
      return str.length > 10 ? str.substring(0, 10) + "..." : str;
    },
    gerenciarMensagem(item) {
      this.dialog = true;
      this.mensagemEditar = item;
      console.log("Gerenciar mensagem com ID:", item);
    },
    buscarMensagensPainel() {
      this.loading = true;
      http
        .get(
          "homenagem/eventos/",
          {
            params: {
              nomeEvento: "Finados2026",
              nomeEmpresa: "Memorial Parque Maceió",
            },
          },
          {
            headers: authHeader(),
          }
        )
        .then((response) => {
          this.serverItems = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao buscar mensagens:", error);
          this.loading = false;
        });
    },
    editarStatusMensagem(idMensagem, status) {
      const statusToast = status;
      http
        .put("homenagem/evento/" + idMensagem + "/aprovar", null, {
          headers: authHeader(),
        })
        .then((response) => {
          this.dialog = false;
          this.buscarMensagensPainel();
          console.log("Mensagem editada com sucesso:", response.data);
          toast.success(
            `Mensagem ${statusToast ? "ativada" : "desativada"} com sucesso!`
          );
        })
        .catch((error) => {
          console.error("Erro ao editar mensagem:", error);
        });
    },
  },
  data() {
    return {
      itemsPerPage: 10,
      search: "",
      loading: false,
      dialog: false,
      headers: [
        {
          title: "Mensagem",
          key: "mensagem",
          sortable: true,
          width: "200px",
        },
        {
          title: "Nome do Cliente",
          key: "nomeCliente",
          sortable: true,
          width: "160px",
        },
        {
          title: "Nome do Homenageado",
          key: "nomeHomenageado",
          sortable: true,
          width: "160px",
        },
        {
          title: "Telefone",
          key: "telefone",
          sortable: true,
          width: "140px",
        },
        { title: "Status", key: "aprovado", sortable: true, width: "80px" },
        {
          title: "Ações",
          key: "acoes",
          sortable: false,
          align: "center",
          width: "120px",
        },
      ],
      mensagemEditar: {},
      serverItems: [],
      items: [
        {
          title: "Voltar",
          disabled: false,
          href: "/admin/painel-despedidas",
        },
      ],
    };
  },
};
</script>

<style scoped>
.mensagens {
  min-height: 78vh !important;
}
.foto_perfil {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
}

.mensagem-container {
  max-width: 300px;
  margin-top: 10px;
  word-wrap: break-word;
  white-space: normal;
}

.botao {
  margin-bottom: 0.6rem;
  margin-right: 0.4rem;
  font-weight: bold;
}
</style>
